import { getToken } from "../../utils";
import { BASE_URL } from "../../endpoints";

const getCustomerPDFReport = async (id: number, data: any) => {
  const token = getToken();

  let valid = false;
  if (token) {
    try {
      const response = await fetch(
        `${BASE_URL}/api/customers/${id}/ton_equivalence_report?customer_name=${encodeURIComponent(
          data.customer_name
        )}&name=${data.name}&position=${data.position}&tax_year=${data.tax_year}&customer_no=${data.customer_nr}&date=${data.date}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );

      var reportResult = await response.json();
      valid =
        reportResult !== null &&
        reportResult.success &&
        reportResult.customer_reports;
    } catch (except) {
      valid = false;
    }
  }

  if (!valid) {
    if (reportResult && reportResult.errors)
      return {
        valid: false,
        message: reportResult.errors,
      };
    return {
      valid: false,
      message: "Something unexpected happened",
    };
  }

  return {
    valid: true,
    data: reportResult.customer_reports,
  };
};

export default getCustomerPDFReport;
